import type { AppLocale, DeepPartialMessageTree } from "@airange/shared/i18n-common";

export const microLabFeedbackMessages: Record<AppLocale, DeepPartialMessageTree> = {
  "zh-CN": {
    microLab: {
      messages: {
        unknownEnumValue: "未定义{kind} ({value})",
        roleCatalogUpdatedAt: "角色目录更新时间：{time}",
        memberDirectoryUpdatedAt: "成员目录更新时间：{time}",
        loadFailed: "读取失败：{message}",
        invalidJsonArray: "请输入 JSON 数组",
        noVersionCreated: "未创建版本",
        searchSchemeName: "搜索方案名称",
        searchExperimentName: "搜索实验名称",
        searchVersionName: "搜索版本名称",
        searchName: "搜索名称",
        searchCode: "搜索编号",
        upstreamNewSharedVersion: "上游有新共享版本",
        syncUpstreamVersion: "可同步上游新版本",
        referencedFrom: "引用自 {name}{versionSuffix}",
        clonedFrom: "克隆自 {name}{versionSuffix}",
        versionSuffix: " v{versionNo}",
        draftSchemeOnlyEditable: "仅草稿方案允许编辑",
        loadSchemeFailed: "加载方案失败",
        loadLibraryEntryFailed: "加载共享条目失败",
        loadLibraryReviewEntryFailed: "加载审核条目失败",
        schemeContextMissing: "方案上下文缺失",
        draftSchemeOnlyManageVersions: "仅草稿方案允许维护版本",
        versionIdMissing: "缺少待编辑版本",
        draftVersionOnlyEditable: "仅草稿版本允许继续编辑",
        draftVersionOnlyReview: "仅草稿版本允许提交共享审核",
        loadEnvironmentCatalogFailed: "加载环境资产失败",
        loadReleasesFailed: "加载发布列表失败",
        loadRunDetailFailed: "加载实验实例详情失败",
        loadRunStatsFailed: "加载执行统计失败",
        loadRunListFailed: "加载实验实例列表失败",
        loadVersionEditorFailed: "加载版本编辑器失败",
        loadSchemeVersionsFailed: "加载方案版本失败",
        loadReviewContextFailed: "加载送审信息失败",
        schemeVersionCreateSuccess: "方案版本已创建",
        schemeVersionUpdateSuccess: "方案版本已更新",
        schemeVersionStepsSaved: "结构化步骤已保存",
        saveSchemeVersionFailed: "保存方案版本失败",
        newDraftVersionPending: "将创建新的草稿版本",
        schemeVersionWorkspaceIntro:
          "目标、手册、环境和结构化步骤都会进入正式版本快照；共享审核和发布后续都基于这个版本页里的真相。",
        environmentCatalogSourceUpdated: "目录来源：{source}，更新时间 {time}",
        environmentCatalogLazyLoad: "环境目录会在打开选择器时加载。",
        environmentAssetPickerScopeHint:
          "环境资产选择器只展示当前账号可引用的资源，并严格按“我的 / 共享给我的 / 公共”三个 scope 切换。",
        submitSharedReviewConfirmTitle: "确认提交共享审核：v{versionNo} {name}？",
        submitSharedReviewConfirmContent:
          "提交后该草稿版本会进入待审核状态，管理员审核前不能再按草稿继续编辑。",
        submitSharedReviewSuccess: "已提交共享审核",
        submitSharedReviewFailed: "提交共享审核失败",
        reviewSubmissionIntro:
          "送审后当前草稿版本会进入待审核状态，管理员审核通过后才会进入共享实验库供其他教员复用。",
        noEnvironmentAssetOptions: "当前没有可选环境资产",
        noKsaCategoryOptions: "当前没有可选 KSA 分类",
        selectEnvironmentAssetFirst: "请先选择一个环境资产",
        archiveSchemeConfirmTitle: "确认归档方案：{name}？",
        archiveSchemeConfirmContent: "归档后该方案不再允许继续编辑或新增版本。",
        archiveSchemeSuccess: "方案已归档",
        archiveSchemeFailed: "归档方案失败",
        loadReleaseSchemeFiltersFailed: "加载发布筛选方案失败",
        loadReleaseContextFailed: "加载发布上下文失败",
        loadReleaseDetailFailed: "加载发布详情失败",
        loadReleaseTargetMembersFailed: "加载发布目标成员失败",
        loadReleaseTargetMemberCandidatesFailed: "加载可补充的目标成员失败",
        searchReleaseTargetRunKeyword: "搜索目标成员 / 用户 / 组织",
        searchReleaseName: "搜索发布名称",
        schemeFallback: "方案 #{id}",
        publishReleaseConfirmTitle: "确认发布：{name}？",
        publishReleaseConfirmContent: "发布后目标成员会按当前发布真相看到并进入实验。",
        publishReleaseSuccess: "发布已生效",
        publishReleaseFailed: "发布失败",
        closeReleaseConfirmTitle: "确认关闭发布：{name}？",
        closeReleaseConfirmContent: "关闭后该发布不再允许成员继续从实验广场进入新实验。",
        closeReleaseSuccess: "发布已关闭",
        closeReleaseFailed: "关闭发布失败",
        archiveReleaseConfirmTitle: "确认归档发布：{name}？",
        archiveReleaseConfirmContent: "归档后该发布只保留审计记录，不再参与后续运营维护。",
        archiveReleaseSuccess: "发布已归档",
        archiveReleaseFailed: "归档发布失败",
        createReleaseSuccess: "发布草稿已创建",
        createReleaseFailed: "创建发布失败",
        releaseCreateIntroTitle: "发布创建会冻结当前方案版本快照",
        releaseCreateIntroDescription:
          "学员后续执行内容按发布快照隔离，不会实时跟随源方案继续变化。",
        releaseSourcePickerHelp:
          "这里按标准“查找带回”选择可发布的当前方案版本；本轮只展示仍可直接发起发布的草稿/已共享版本。",
        releaseSourceSelectionEmpty: "还没有选择来源方案版本",
        releaseSettingsStepNotice:
          "先把发布对谁可见、手册是否开放这些发布级规则定下来，再继续选择目标成员。",
        releaseTargetsStepNotice:
          "如果是定向发布，请在这里明确勾选目标成员；全部成员可见则直接沿用当前启用成员范围。",
        releaseConfirmStepNotice: "最后一步只做快照确认，不再把复杂配置塞回抽屉里。",
        releaseConfirmStepDescription: "确认后会按当前来源方案版本与成员范围生成正式发布草稿。",
        releaseAllMembersSummary: "当前会把所有启用的 portal 成员都纳入可见范围，共 {count} 人。",
        releaseAllMembersSnapshotSummary: "本次发布将面向当前全部启用成员快照，共 {count} 人。",
        releaseTargetMembersPickerHelp:
          "这里按标准“查找带回”多选目标成员，只展示当前启用的 portal 成员。",
        releaseTargetMembersSelectionSummary: "已选择 {count} 名目标成员",
        noReleaseSourceOptionsTitle: "当前没有可用于创建发布的来源方案版本",
        noReleaseSourceOptionsDescription:
          "请先在“我的实验方案 / 方案版本管理”里准备一个草稿或已共享的当前版本，再回来创建发布。",
        noReleaseTargetMemberOptions:
          "当前没有可选目标成员，请先在成员管理页准备启用的 portal 成员。",
        noSchemeShareMembers: "当前没有匹配的可共享成员。",
        allMembersVisible: "所有成员可见",
        targetedMembersVisible: "定向成员可见",
        allMembersVisibleDynamically: "所有成员动态可见",
        targetedMembersRequired: "定向发布必须选择至少一名目标成员",
        addReleaseTargetMembersSuccess: "目标成员已补充",
        addReleaseTargetMembersFailed: "补充目标成员失败",
        noAvailableReleaseTargetMembersToAdd: "当前没有可继续补充的目标成员。",
        releaseTargetMembersAddRequired: "请至少选择一名要添加的目标成员",
        targetCountSuffix: "待发布",
        notApplicable: "不适用",
        releaseNameAutoGenerated: "不填时，后端会按“方案名 + 版本号”生成默认名称。",
        createSchemeSuccess: "方案已创建",
        updateSchemeSuccess: "方案已更新",
        saveSchemeFailed: "保存方案失败",
        loadSchemeShareFailed: "加载方案共享设置失败",
        updateSchemeShareSuccess: "方案共享设置已更新",
        updateSchemeShareFailed: "更新方案共享设置失败",
        searchScheme: "搜索方案",
        searchTag: "搜索标签",
        defaultReusedSchemeName: "{name} - 复用方案",
        defaultReusedVersionName: "{name} - 复用版",
        reuseLibraryEntrySuccess: "{mode}完成，已生成方案 {code}",
        reuseLibraryEntryFailed: "复用共享方案失败",
        libraryReuseIntroTitle: "引用会保留上游关系，克隆会复制出独立副本",
        libraryReuseSourceDescription: "当前来源：{schemeName} / v{versionNo} {versionName}",
        libraryReviewApproveConfirmTitle: "确认通过共享审核：{name}？",
        libraryReviewRejectConfirmTitle: "确认驳回共享审核：{name}？",
        libraryReviewOfflineConfirmTitle: "确认下线共享条目：{name}？",
        libraryReviewApproveConfirmContent:
          "确认后该版本会进入共享实验库，其他教员可以引用或克隆。",
        libraryReviewRejectConfirmContent: "确认后该版本会退回草稿状态，需要创建人重新修改并送审。",
        libraryReviewOfflineConfirmContent:
          "确认后该共享条目会从共享实验库下线，后续不能再作为共享版本复用。",
        libraryReviewApproveSuccess: "共享审核已通过",
        libraryReviewRejectSuccess: "共享审核已驳回",
        libraryReviewOfflineSuccess: "共享条目已下线",
        reviewLibraryEntryFailed: "审核共享条目失败",
        libraryReviewOfflineIntroTitle: "当前操作会把已共享条目下线",
        libraryReviewDecisionIntroTitle: "当前操作会决定这次共享审核结果",
        searchRunKeyword: "搜索学生 / 用户 / 发布 / 实验",
        runHistoryAuditTitle: "历史轮次与改判留痕",
        runHistoryAuditDescription: "重置不会覆盖旧实例，人工改判也不会无痕覆盖系统结果。",
        manualOverrideRequiredTitle: "人工改判必须留痕",
        manualOverrideRequiredDescription:
          "这里不会直接覆盖系统结果，而是会产生一条正式改判审计记录。",
        resetRunKeepsHistoryTitle: "重置不会清空旧记录",
        resetRunKeepsHistoryDescription: "系统会保留历史轮次，并为该学员新建一条新的实验实例。",
        confirmManualOverrideTitle: "确认人工改判 Run #{id}？",
        confirmManualOverrideDescription: "改判不会覆盖系统结果，而是新增一条正式改判审计记录。",
        confirmManualOverrideAction: "确认改判",
        confirmResetRunTitle: "确认重置重开 Run #{id}？",
        confirmResetRunDescription: "系统会保留历史轮次，并为该学员新开一条新的实验实例。",
        confirmResetRunAction: "确认重开",
        manualOverrideSuccess: "人工改判已记录",
        manualOverrideFailed: "人工改判失败",
        resetRunSuccess: "已为该学员新开一轮实验实例",
        resetRunFailed: "重置实验失败",
      },
    },
  },
  en: {
    microLab: {
      messages: {
        invalidJsonArray: "Please enter a JSON array",
        noVersionCreated: "No version created",
        searchSchemeName: "Search scheme name",
        searchExperimentName: "Search experiment name",
        searchVersionName: "Search version name",
        searchName: "Search name",
        searchCode: "Search code",
        upstreamNewSharedVersion: "A newer shared upstream version is available",
        syncUpstreamVersion: "Sync newer upstream version",
        referencedFrom: "Referenced from {name}{versionSuffix}",
        clonedFrom: "Cloned from {name}{versionSuffix}",
        versionSuffix: " v{versionNo}",
        draftSchemeOnlyEditable: "Only draft schemes can be edited",
        loadSchemeFailed: "Failed to load scheme",
        loadLibraryEntryFailed: "Failed to load the shared entry",
        loadLibraryReviewEntryFailed: "Failed to load the review entry",
        schemeContextMissing: "Scheme context is missing",
        draftSchemeOnlyManageVersions: "Only draft schemes can manage versions",
        versionIdMissing: "Missing version to edit",
        draftVersionOnlyEditable: "Only draft versions can continue editing",
        draftVersionOnlyReview: "Only draft versions can be submitted for shared review",
        loadEnvironmentCatalogFailed: "Failed to load environment assets",
        loadReleasesFailed: "Failed to load releases",
        loadRunDetailFailed: "Failed to load lab instance details",
        loadRunStatsFailed: "Failed to load run statistics",
        loadRunListFailed: "Failed to load run instances",
        loadVersionEditorFailed: "Failed to load the version editor",
        loadSchemeVersionsFailed: "Failed to load scheme versions",
        loadReviewContextFailed: "Failed to load the review context",
        schemeVersionCreateSuccess: "Scheme version created",
        schemeVersionUpdateSuccess: "Scheme version updated",
        schemeVersionStepsSaved: "Structured steps saved",
        saveSchemeVersionFailed: "Failed to save the scheme version",
        newDraftVersionPending: "A new draft version will be created",
        schemeVersionWorkspaceIntro:
          "Objectives, manuals, environment assets, and structured steps all become part of the formal version snapshot. Shared review and releases will continue to use this version page as the source of truth.",
        environmentCatalogSourceUpdated: "Catalog source: {source}, updated at {time}",
        environmentCatalogLazyLoad: "The environment catalog loads when you open the picker.",
        environmentAssetPickerScopeHint:
          "The picker only shows referenceable assets and switches strictly by the Mine / Shared with me / Public scopes.",
        submitSharedReviewConfirmTitle: "Submit shared review: v{versionNo} {name}?",
        submitSharedReviewConfirmContent:
          "After submission, this draft version enters pending review and can no longer be edited as a draft until an admin completes the review.",
        submitSharedReviewSuccess: "Submitted for shared review",
        submitSharedReviewFailed: "Failed to submit for shared review",
        reviewSubmissionIntro:
          "After submission, the current draft version enters pending review. It is added to the shared library for other instructors to reuse only after admin approval.",
        noEnvironmentAssetOptions: "No environment assets are currently available",
        noKsaCategoryOptions: "No KSA categories are currently available",
        selectEnvironmentAssetFirst: "Please select an environment asset first",
        archiveSchemeConfirmTitle: "Archive scheme: {name}?",
        archiveSchemeConfirmContent:
          "After archiving, this scheme can no longer be edited or receive new versions.",
        archiveSchemeSuccess: "Scheme archived",
        archiveSchemeFailed: "Failed to archive scheme",
        loadReleaseSchemeFiltersFailed: "Failed to load release scheme filters",
        loadReleaseContextFailed: "Failed to load the release context",
        loadReleaseDetailFailed: "Failed to load release details",
        loadReleaseTargetMembersFailed: "Failed to load release target members",
        loadReleaseTargetMemberCandidatesFailed:
          "Failed to load target members that can still be added",
        searchReleaseTargetRunKeyword: "Search target member / user / organization",
        searchReleaseName: "Search release name",
        schemeFallback: "Scheme #{id}",
        publishReleaseConfirmTitle: "Publish release: {name}?",
        publishReleaseConfirmContent:
          "After publishing, target members will see and enter the lab from this release snapshot.",
        publishReleaseSuccess: "Release published",
        publishReleaseFailed: "Failed to publish the release",
        closeReleaseConfirmTitle: "Close release: {name}?",
        closeReleaseConfirmContent:
          "After closing, members can no longer start new labs from the square through this release.",
        closeReleaseSuccess: "Release closed",
        closeReleaseFailed: "Failed to close the release",
        archiveReleaseConfirmTitle: "Archive release: {name}?",
        archiveReleaseConfirmContent:
          "After archiving, this release is kept only for audit history and no longer participates in operations.",
        archiveReleaseSuccess: "Release archived",
        archiveReleaseFailed: "Failed to archive the release",
        createReleaseSuccess: "Release draft created",
        createReleaseFailed: "Failed to create the release",
        releaseCreateIntroTitle: "Creating a release freezes the current scheme version snapshot",
        releaseCreateIntroDescription:
          "Learner execution stays isolated by release snapshot and does not continue to track live changes from the source scheme.",
        releaseSourcePickerHelp:
          "Use the standard picker here to choose the current scheme version that can be released.",
        releaseSourceSelectionEmpty: "No source scheme version has been selected yet",
        releaseSettingsStepNotice:
          "Lock down release-level rules like visibility and manual exposure first, then continue to target members.",
        releaseTargetsStepNotice:
          "If this is a targeted release, explicitly choose the target members here; otherwise the current active-member scope is used directly.",
        releaseConfirmStepNotice:
          "The final step is only for snapshot confirmation and no longer hides complex settings in a drawer.",
        releaseConfirmStepDescription:
          "Confirmation creates the formal release draft from the current source scheme version and target scope.",
        releaseAllMembersSummary:
          "All active portal members are included in the visible scope, {count} in total.",
        releaseAllMembersSnapshotSummary:
          "This release snapshot will face all currently active members, {count} in total.",
        releaseTargetMembersPickerHelp:
          "Use the standard picker here to select multiple target members from the current active portal members.",
        releaseTargetMembersSelectionSummary: "{count} target members selected",
        noReleaseSourceOptionsTitle:
          "No source scheme version is currently available for creating a release",
        noReleaseSourceOptionsDescription:
          "Prepare a current shared scheme version in My Schemes / Scheme Version Management first, then return to create the release.",
        noReleaseTargetMemberOptions:
          "There are no selectable target members yet. Prepare active portal members in Member Management first.",
        noSchemeShareMembers: "No matching members are available for scheme sharing.",
        allMembersVisible: "Visible to all members",
        targetedMembersVisible: "Visible to targeted members",
        allMembersVisibleDynamically: "Dynamically visible to all members",
        targetedMembersRequired: "Targeted releases must select at least one member",
        addReleaseTargetMembersSuccess: "Target members were added",
        addReleaseTargetMembersFailed: "Failed to add target members",
        noAvailableReleaseTargetMembersToAdd:
          "There are no additional target members available to add right now.",
        releaseTargetMembersAddRequired: "Select at least one member to add",
        targetCountSuffix: "pending release",
        notApplicable: "N/A",
        releaseNameAutoGenerated:
          "If left blank, the backend generates a default name from the scheme name and version number.",
        createSchemeSuccess: "Scheme created",
        updateSchemeSuccess: "Scheme updated",
        saveSchemeFailed: "Failed to save the scheme",
        loadSchemeShareFailed: "Failed to load scheme sharing settings",
        updateSchemeShareSuccess: "Scheme sharing settings updated",
        updateSchemeShareFailed: "Failed to update scheme sharing settings",
        searchScheme: "Search scheme",
        searchTag: "Search tag",
        defaultReusedSchemeName: "{name} - Reused Scheme",
        defaultReusedVersionName: "{name} - Reused Version",
        reuseLibraryEntrySuccess: "{mode} completed. Generated scheme {code}",
        reuseLibraryEntryFailed: "Failed to reuse the shared scheme",
        libraryReuseIntroTitle:
          "Reference keeps the upstream link, while clone creates an independent copy",
        libraryReuseSourceDescription: "Current source: {schemeName} / v{versionNo} {versionName}",
        libraryReviewApproveConfirmTitle: "Approve shared review: {name}?",
        libraryReviewRejectConfirmTitle: "Reject shared review: {name}?",
        libraryReviewOfflineConfirmTitle: "Take shared entry offline: {name}?",
        libraryReviewApproveConfirmContent:
          "After confirmation, this version enters the shared library and other instructors can reference or clone it.",
        libraryReviewRejectConfirmContent:
          "After confirmation, this version returns to draft status and the creator must revise and resubmit it.",
        libraryReviewOfflineConfirmContent:
          "After confirmation, this shared entry is removed from the shared library and can no longer be reused as a shared version.",
        libraryReviewApproveSuccess: "Shared review approved",
        libraryReviewRejectSuccess: "Shared review rejected",
        libraryReviewOfflineSuccess: "Shared entry taken offline",
        reviewLibraryEntryFailed: "Failed to review the shared entry",
        libraryReviewOfflineIntroTitle: "This action will take the shared entry offline",
        libraryReviewDecisionIntroTitle: "This action will decide the shared review result",
        searchRunKeyword: "Search learner / user / release / scheme",
        runHistoryAuditTitle: "Attempt History and Override Audit",
        runHistoryAuditDescription:
          "Resetting does not overwrite old instances, and manual overrides do not silently replace the system result.",
        manualOverrideRequiredTitle: "Manual overrides must keep an audit trail",
        manualOverrideRequiredDescription:
          "This does not overwrite the system result directly. It creates a formal override audit record.",
        resetRunKeepsHistoryTitle: "Reset does not clear old records",
        resetRunKeepsHistoryDescription:
          "The system keeps the attempt history and creates a new lab instance for this learner.",
        confirmManualOverrideTitle: "Confirm manual override for Run #{id}?",
        confirmManualOverrideDescription:
          "This will not overwrite the system result. It creates a formal override audit record.",
        confirmManualOverrideAction: "Confirm Override",
        confirmResetRunTitle: "Confirm reset and reopen for Run #{id}?",
        confirmResetRunDescription:
          "The system keeps the attempt history and opens a new lab instance for this learner.",
        confirmResetRunAction: "Confirm Reopen",
        manualOverrideSuccess: "Manual override recorded",
        manualOverrideFailed: "Failed to record manual override",
        resetRunSuccess: "Opened a new lab instance for this learner",
        resetRunFailed: "Failed to reset the lab",
      },
    },
  },
  ja: {
    microLab: {
      messages: {
        noSchemeShareMembers: "共有対象として一致するメンバーがいません。",
      },
    },
  },
};
